<template>
  <div class="bindEnterprise">
    <div>
      <BoundEnterprise @getList="getList" :companyList="companyList" v-if="true"></BoundEnterprise>
      <div v-if="companyList.length === 0" class="bindEnterprise_img">
        <img src="@/assets/images/nodata.png" alt="">
        <span>还未有绑定的企业，快去绑定吧~</span>
      </div>
      <div @click="bindEnterprise" class="bindEnterprise_btn bindEnterprise_card">新增绑定企业</div>
      <div @click="bindReturn" class="bindEnterprise_btn bindEnterprise_return">返回</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import BoundEnterprise from './components/boundEnterprise.vue';

export default {
  name: 'bindEnterprise',
  data() {
    return {
      companyList: [],
    };
  },
  components: {
    BoundEnterprise,
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  mounted() {
    this.getList()
  },

  methods: {
    ...mapMutations('publicPage', ['updateState']),

    getList() {
      this.$api.PublicPage.getBindingEnterprise({}).then((res) => {
        this.companyList = [...res.data];
      });
    },
    bindEnterprise() {
      localStorage.setItem('returnPage', '/supermarket/v2/bindEnterprise');
      this.$router.push('/supermarket/v2/bindingEnterprise');
    },
    bindReturn() {
      this.$router.push('/supermarket/v2/personalCenter');
    },
  },
};
</script>
<style scoped>
.bind {
  width: 100%;
  background: url('~@/assets/images/nodata.png') no-repeat top center;
  background-size: contain;
  margin-top: 30px;
}
.bindEnterprise_btn {
  height: 44px;
  margin: 0 16px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.bindEnterprise_return {
  border: 1px solid #ff6538;
  color: #ff6538;
  margin-top: 12px;
}
.bindEnterprise_card {
  background: #ff6538;
}

.bindEnterprise_img img{
  margin-top: 30px;
  width: 100%;
}
.bindEnterprise_img span {
  display: block;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #b8c4cc;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 40px;
  margin-top: -90px;
}
</style>
